import {useHubQuery} from '../../QueryProvider'

export const useGetOrderCancellationOptions = (orderId: string, checkSum?: string) => {
  return useHubQuery('orderCancellationOptions', [orderId, checkSum], {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}
